/** @format */

import { dateFormate, formatDate, formateChange12Hour } from "./DateAndFormat";
import { defaultRules } from "./defaultMessage";

const findDefaultRules = (name, orderId) => {
  const findValue = defaultRules.find(
    (item) => item?.order === orderId && item?.name === name
  )?.value;
  return findValue;
};

export const rulesFunction = (value, name, orderId) => {
  const findValue = value?.[0]?.[name]?.find(
    (item) => item?.order === orderId
  )?.value;
  return findValue === undefined ? findDefaultRules(name, orderId) : findValue;
};
export const carouselSlider = (value, dataLength) => {
  const slide = value <= dataLength ? value : dataLength || 1;
  return slide;
};

export const dateSkip = (startCount, endCount) => {
  const today = new Date();
  const futureDate = new Date();
  today.setDate(today.getDate() + startCount);
  let count = startCount;
  while (endCount >= count) {
    futureDate.setDate(today.getDate() + count);
    const day = futureDate.getDay();
    count++;
    if (day === 0 || day === 6) endCount++;
  }
  return { start: formatDate(today), end: formatDate(futureDate) };
};
export const businessCalender = (startCount, endCount) => {
  const today = new Date();
  const futureDate = new Date(today); // Copy of today to avoid modifying original

  let workingDays = startCount;
  while (workingDays < endCount) {
    futureDate.setDate(futureDate.getDate() + 1);
    const day = futureDate.getDay();

    if (day !== 0 && day !== 6) {
      workingDays++;
    }
  }
  return { start: today, end: futureDate };
};

export const businessCalenderStartDate = (startCount = 0) => {
  const today = new Date();
  today.setDate(today.getDate() + startCount);

  // Move to next business day if today is a weekend
  while (today.getDay() === 0 || today.getDay() === 6) {
    today.setDate(today.getDate() + 1);
  }

  return today;
};

export const normalCalender = (startCount, endCount) => {
  const currentDate = new Date();
  const futureDate = new Date();
  futureDate.setDate(new Date().getDate() + endCount);
  return { start: currentDate, end: futureDate };
};

export const endDateFunction = (rulesConfig = []) => {
  let dateType = rulesFunction(rulesConfig, "appointment", 2, "BusinessDays");
  let count = parseFloat(rulesFunction(rulesConfig, "appointment", 1, 10));
  if (dateType === "BusinessDays") {
    const { end: date } = businessCalender(0, count);
    return date;
  } else {
    const { end: date } = normalCalender(0, count);
    return date;
  }
};

export const startDateFunction = (rulesConfig = []) => {
  const dateType = rulesFunction(
    rulesConfig,
    "appointment",
    16,
    "BusinessDays"
  );
  const count = parseFloat(rulesFunction(rulesConfig, "appointment", 15, 2));

  if (dateType === "BusinessDays") {
    const { end: date } = businessCalender(0, count);
    if (count !== 0) date.setHours(0, 0, 0, 0);
    return date;
  } else if (dateType === "CalendarDays") {
    const today = new Date();
    today.setDate(today.getDate() + count);
    if (count !== 0) today.setHours(0, 0, 0, 0);
    return today;
  } else {
    const today = new Date();
    today.setHours(today?.getHours() + count);

    return today;
  }
};

export function setCookie(
  key = "ssoToken",
  value,
  path = "/",
  duration = 3600000
) {
  const date = new Date();
  date.setTime(date.getTime() + duration); // Convert days to milliseconds
  const expires = `expires=${date.toUTCString()}`;
  const domainAttr = `domain=.layline.live`;
  document.cookie = `${key}=${value}; ${expires}; ${domainAttr}; path=${path};`;
}

export function getCookie(name) {
  const cookies = document?.cookie?.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie?.split("=");
    if (key === name) return value;
  }
  return null;
}
export function deleteCookie(key = "ssoToken") {
  const pastDate = new Date(0);
  const expires = `expires=${pastDate.toUTCString()}`;
  const domainAttr = `domain=.layline.live`;
  document.cookie = `${key}=; ${expires}; ${domainAttr}; path=/;`;
}

export const startCapitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const replaceDateTime = (msg, date, time) => {
  const message = msg
    .replace("APPTDATE", dateFormate(date))
    .replace("APPTTIME", formateChange12Hour(time));
  return message;
};
